// extracted by mini-css-extract-plugin
export default {"main":"Vaa-z"};